import { IExam } from "../models/exam/exam.model";
import { EExamKey } from "../enums/exam-key.enum";

/**
 * The short form of an exam, used wherever the full name does not fit: switches, score boxes,
 * badges. The key is already the code the product speaks in ("tyt" → TYT), so it is only
 * uppercased — no abbreviating of the name.
 */
export function examShortName(exam?: IExam | null, examKey?: EExamKey | null): string {
  const key = exam?.examKey ?? examKey;
  return key ? key.toLocaleUpperCase("tr-TR") : "";
}
